import Api from "./Api";
import axios from "axios";

const baseHeaders = {
  "Content-Type": "application/json",
  "Accept": "application/json",
};

export default {
  login(payload) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/login`, payload, {
      headers: baseHeaders,
      withCredentials: true,
    });
  },
  register(payload) {
    return Api().post(`register`, payload, { headers: baseHeaders });
  },
  forgetPassword(payload) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/forgot-password`, payload, {
      headers: baseHeaders,
      withCredentials: true,
    });
  },
  resetPassword(payload) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/reset-password`, payload, {
      headers: baseHeaders,
      withCredentials: true,
    });
  },
  getUserBytoken() {
    return Api().get('/profile');
  },
  logout() {
    return Api().post(`logout`);
  },
  checkUserPassword(payload) {
    return Api().post('/check-login', payload);
  },
};